import script from "./SuspanceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspanceForm.vue?vue&type=script&setup=true&lang=js"

import "./SuspanceForm.vue?vue&type=style&index=0&id=1eecc8aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eecc8aa"]])

export default __exports__